import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { focusProps } from './focus'
import { disabledProps } from './disabled'

const buttonProps = {
	_focus: focusProps,
	_disabled: disabledProps,
	_hover: { textDecoration: 'none' },
}

const solid = defineStyle({
	_hover: { color: 'white' },
})

const basic = defineStyle({
	background: 'white',
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: 'gray.300',
	boxShadow: 'sm',
	_hover: {
		background: 'gray.50',
		color: 'gray.900',
	},
	_active: {
		background: 'gray.100',
		boxShadow: 'none',
	},
})

const subtle = defineStyle({
	borderRadius: 'base',
	background: 'primary.100',
	color: 'primary.700',
	_hover: {
		background: 'primary.200',
		color: 'primary.800',
	},
	_active: {
		background: 'primary.300',
		boxShadow: 'none',
	},
})

export const buttonTheme = defineStyleConfig({
	defaultProps: {
		variant: 'basic',
		colorScheme: 'primary',
	},
	sizes: {
		sm: { ...buttonProps, px: 3 },
		md: { ...buttonProps, px: 4 },
		lg: buttonProps,
	},
	variants: { basic, solid, subtle },
})
